var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 109,
    viewBox: "0 0 138 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6599 48.23C25.4909 48.23 32.6499 41.071 32.6499 32.24C32.6499 23.409 25.4909 16.25 16.6599 16.25C7.82888 16.25 0.669922 23.409 0.669922 32.24C0.669922 41.071 7.82888 48.23 16.6599 48.23Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9294 104.31H6.10938V93.7498H49.3694V54.7498H96.8594V14.2998H107.409V65.2998H59.9294V104.31Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.761 34.8098L102.141 15.1798L82.5107 34.8098L75.0508 27.3498L102.141 0.259766L129.231 27.3498L121.761 34.8098Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.744 75.6056L104.373 100.977L111.833 108.437L137.204 83.0655L129.744 75.6056Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.839 75.5956L104.379 83.0557L129.75 108.427L137.21 100.967L111.839 75.5956Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIcon2);
export default __webpack_public_path__ + "static/media/process-icon2.7e638c9463d4baba03a9b8e395fd17c4.svg";
export { ForwardRef as ReactComponent };